import React from 'react';
import {withTranslation} from 'react-i18next';
import PropTypes from 'prop-types';

import MerchantDetailView from '../components/MerchantDetailView';

function MerchantDetail() {
  return <MerchantDetailView />;
}

MerchantDetail.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('merchant')(MerchantDetail);
